import { styled } from "@mui/material/styles"

const RoiCardContainer = styled('div')<{ backgroundColor: string }>(({ backgroundColor }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: backgroundColor,
    padding: '44px 32px 36px 32px',
    gap: '6px',
    height: '291px',
    '@media (max-width: 1024px)': {
        height: '260px',
        padding: '32px 24px 24px 24px',
    }
}))

const RoiCardIcon = styled('img')({
    width: '72px',
    height: '72px',
    '@media (max-width: 1024px)': {
        width: '56px',
        height: '56px',
    }
})

const RoiCardStat = styled('p')<{ statColor: string }>(({ statColor }) => ({
    color: statColor,
    textAlign: 'center',
    fontSize: '48px',
    fontWeight: '700',
    lineHeight: 'normal',
    '@media (max-width: 1024px)': {
        fontSize: '36px',
    }
}))

const RoiCardDescription = styled('p')({
    color: '#021A1A',
    textAlign: 'center',
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '18px',
    '@media (max-width: 1024px)': {
        fontSize: '12px',
        lineHeight: '16px',
    }
})

interface RoiCardProps {
    icon: string;
    stat: string;
    description: string;
    statColor?: string;
    backgroundColor?: string;
}

export const RoiCard = ({ backgroundColor = '#00644B', icon, stat, description, statColor = "#00E378" }: RoiCardProps) => {
    return (
        <RoiCardContainer backgroundColor={backgroundColor}>
            <RoiCardIcon src={icon} alt="icon" />
            <RoiCardStat statColor={statColor}>{stat}</RoiCardStat>
            <RoiCardDescription>{description}</RoiCardDescription>
        </RoiCardContainer>
    )
}   
